import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';

class UnsupportedError extends Component {
  render() {
    const {
      onClick,
      messageId,
      ctaMessageId,
      classes,
    } = this.props;
    return (
      <div className={classes}>
        <p className="text-600 body-md"><FormattedMessage id={messageId} /></p>
        <Button color="primary" onClick={onClick}><FormattedMessage id={ctaMessageId} /></Button>
      </div>
    );
  }
}

UnsupportedError.defaultProps = {
  onClick: () => {},
  classes: '',
};

UnsupportedError.propTypes = {
  onClick: PropTypes.func,
  messageId: PropTypes.string.isRequired,
  ctaMessageId: PropTypes.string.isRequired,
  classes: PropTypes.string,
};

export default UnsupportedError;



// WEBPACK FOOTER //
// ./src/components/UnsupportedError/UnsupportedError.jsx